import { render, staticRenderFns } from "./NodeAllocationCard.vue?vue&type=template&id=92f85230&scoped=true&"
import script from "./NodeAllocationCard.vue?vue&type=script&lang=js&"
export * from "./NodeAllocationCard.vue?vue&type=script&lang=js&"
import style0 from "./NodeAllocationCard.vue?vue&type=style&index=0&id=92f85230&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92f85230",
  null
  
)

export default component.exports